import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AgentOnboardingAudience, type AgentOnboardingTimeSinkId } from './agentOnboardingAnalytics';
import META from './useTrackAgentOnboardingCompleted.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type UseTrackAgentOnboardingCompletedParams = {
  audience: AgentOnboardingAudience;
  outcome: AgentOnboardingTimeSinkId;
};

export const useTrackAgentOnboardingCompleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentOnboardingCompleted = useCallback(
    (params: UseTrackAgentOnboardingCompletedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentOnboardingCompleted };
};
